/* 
Mixin used by our task-related components.
*/
import * as noticeAction from "@/store/notices/action-types";
import * as noticeMutation from "@/store/notices/mutation-types";

export default {
  methods: {
    canRunTask(claimType) {
      return this.$store.getters.claims.includes(claimType);
    },
    getIcon(taskType) {
      switch (taskType) {
        case "ImportInScopeProviders":
        case "UploadInScopeProviders":
          return "school";
        case "ImportLevyParameters":
        case "UploadLevyParameters":
          return "settings_input_component";
        case "UploadOfflineLevyParameters":
          return "publish";
        case "Delete":
          return "delete";
        case "StartCommunicating":
          return "forum";
        case "StartInvoicing":
          return "power_settings_new";
        case "Finalise":
        case "UpdateFinalisationDetails":
          return "power_off";
        case "RaiseInvoice":
          return "cloud_upload";
        case "ReverseInvoice":
          return "backspace";
        case "CalculateLevy":
          return "attach_money";
        case "CreateSapCustomerAccount":
          return "shopping_cart";
        case "Pause":
        case "Unpause":
          return "pause";
        case "Favourite":
        case "Unfavourite":
          return "favorite_border";
        case "SetPaymentStatus":
          return "watch_later";
        case "AdjustLevyCalculations":
        case "EditLevyCalculationAdjustments":
          return "change_history";
        case "ChangeInvoiceAddressee":
        case "EditInvoiceAddressee":
          return "receipt";
        case "RemoveProvider":
        case "RemovePreviouslyAddedProvider":
          return "assignment_return";
        case "SendAdhocNotice":
          return "contact_mail";
        case "SendInformationSessionNotice":
        case "SendAdditionalInformationSessionNotice":
          return "forum";
        case "PublishPublicEstimator":
          return "publish";
        case "UnpublishPublicEstimator":
          return "undo";
        default:
          if (taskType.includes("Revert") || taskType.includes("Undo")) {
            return "undo";
          } else if (taskType.includes("Notice")) {
            return "email";
          }
          return "";
      }
    },
    getApplicabilityDescription(task) {
      const ac = task.applicableCount;
      const na = task.notApplicableCount;
      if (ac + na == 0) {
        return "There are currently no in-scope providers.";
      }
      if (na == 0) {
        return `Currently applicable to all ${this.pluralise(ac)}.`;
      }
      if (ac == 0) {
        return "Currently not applicable to any providers.";
      }
      return `Applicable to ${this.pluralise(ac)}, not applicable to ${this.pluralise(na)}.`;
    },
    searchTasks(tasks, levyCollectionTaskTypeDescriptions, search) {
      if (tasks && levyCollectionTaskTypeDescriptions && search) {
        return tasks.filter(
          t =>
            levyCollectionTaskTypeDescriptions[t.type].toLowerCase().indexOf(search) > -1 ||
            t.description.toLowerCase().indexOf(search) > -1
        );
      } else {
        return tasks;
      }
    },
    pluralise(count) {
      return `${count} provider${count == 1 ? "" : "s"}`;
    },
    getTaskProgress(task) {
      const ac = task.applicableCount;
      const na = task.notApplicableCount;
      const total = ac + na;
      if (total) {
        return (ac / total) * 100;
      }
      return 0;
    },
    getTaskColour(task) {
      const progress = this.getTaskProgress(task);
      return progress < 100 ? "orange" : "green";
    },
    getTextColour(task) {
      return task.applicableCount ? "" : "grey--text";
    },
    showNotices(templateType, levyCollectionId, providerId) {
      this.$store.commit(noticeMutation.LIST_CLEAR_CRITERIA);
      this.$store.commit(noticeMutation.LIST_SET_CRITERIA, {
        type: [templateType],
        levyCollectionId: levyCollectionId,
        providerId: providerId
      });
      this.$store.dispatch(noticeAction.LIST);
      this.$emit("showNotices");
    }
  }
};
